module.exports = __webpack_public_path__ + "img/3kidswred.68849181.jpg";